/* ContentBarComponent.js */

"use strict";
const EventEmitter = require('events').EventEmitter;
const Renderer = require("./ContentBarRenderer");
const _ = require("lodash");

/**
 * @typedef contentBarConfig
 * @property {Array.<ItemDefinition>} items
 */

/**
 * @typedef ItemDefinition
 * @property {String} title
 * @property {String} type - info(default), link
 */

/**
 * @class ContentBarComponent
 */
class ContentBarComponent extends EventEmitter {
    /**
     * @constructor
     * @param {contentBarConfig}
     */
    constructor(contentBarConfig) {
        super();
        if(_.has(contentBarConfig,"veilContainer")){
            this.veilContainer = contentBarConfig.veilContainer;
        }else{
            throw new Error('Content Bar - Missing veilContainer property.');
        }
        this.items = _.has(contentBarConfig,"items") ? contentBarConfig.items : [];
        this._renderer = new Renderer(this);
        this._registerListeners();
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners(){

    }
    _unregisterListeners(){

    }
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get renderer(){
        return this.getRenderer();
    }
    getRenderer(){
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        return this._renderer._shutdown()
            .then(() => this._renderer = undefined)
            .catch(err => console.log("Error shutting down ContentBarComponent: ", err));
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/
    itemClicked(item){
        this.emit("item-clicked",item);
    }
    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/
    
    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/
    get veilShown(){
        return this.isVeilShown();
    }
    
    set veilShown(veilShown){
        if(!veilShown){
            this.emit("veil.hide");
        }
    }
    
    isVeilShown(){
        let ren = this.renderer;
        return ren.isVeilShown();
    }
    
    addContent(itemDefinition){
        this.items.push(itemDefinition);
        this.emit("ContentChanged");
    }
    addContents(items){
        this.items = items;
        this.emit("ContentChanged");
    }
    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports=ContentBarComponent;